import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const knowledgeKF: AppRouteModule = {
  path: '/knowledge/kf',
  name: 'knowledgeKF',
  component: LAYOUT,
  // redirect: 'question',
  meta: {
    orderNo: -70,
    icon: 'ant-design:zhihu-outlined',
    title: '知识库',
  },
  children: [
    {
      path: 'kf',
      name: 'Kf',
      meta: {
        title: '客服知识库',
        icon: 'ant-design:aliwangwang-outlined'
      },
      children: [
        {
          path: 'question',
          name: 'Question',
          component: () => import('/@/views/knowledge/kf/Question.vue'),
          meta: {
            title: '客服问题管理',
            icon: 'ant-design:whats-app-outlined'
          },
        },
        {
          path: 'common_words',
          name: 'Common_words',
          component: () => import('/@/views/knowledge/kf/CommonWords.vue'),
          meta: {
            title: '常用语管理',
            icon: 'ant-design:clock-circle-outlined'
          },
        }, {
          path: 'traffic',
          name: 'Traffic',
          component: () => import('/@/views/knowledge/kf/Traffic.vue'),
          meta: {
            title: '电话知识库管理',
            icon: 'ant-design:whats-app-outlined'
          },
        }]
    },
    {
      path: 'robot',
      name: 'Robot',
      meta: {
        title: '机器人知识库',
        icon: 'ant-design:reddit-outlined'
      },
      children: [
        {
          path: 'robotQuestion',
          name: 'RobotQuestion',
          component: () => import('/@/views/knowledge/robot/RobotQuestion.vue'),
          meta: {
            // affix: true,
            title: '热点问题管理',
            icon: 'ant-design:comment-outlined'
          },
        },
        {
          path: 'selfService',
          name: 'SelfService',
          component: () => import('/@/views/knowledge/robot/SelfService.vue'),
          meta: {
            title: '自助服务',
            icon: 'ant-design:android-outlined'
          },
        },
      ],
    },
    {
      path: 'record',
      name: 'Record',
      meta: {
        title: '记录数据',
        icon: 'ant-design:star-outlined'
      },
      children: [
        {
          path: 'evaluation',
          name: 'Evaluation',
          component: () => import('/@/views/knowledge/record/Evaluation.vue'),
          meta: {
            // affix: true,
            title: '评价记录',
            icon: 'ant-design:gift-outlined'
          },
        },
        {
          path: 'history',
          name: 'History',
          component: () => import('/@/views/knowledge/record/History.vue'),
          meta: {
            title: '历史记录',
            icon: 'ant-design:cloud-outlined'
          },
        },
      ],
    },
  ],
};

export default knowledgeKF;
